<template>
  <va-form ref="form" :item="domain" v-model="form" :requiredFieldsSet="requiredFieldsSet">
    <v-card class="spacing-bottom--24">
      <v-card-title>{{ $t("resources.domains.create_subdomain_title") }} </v-card-title>
      <v-card-subtitle>{{ $t("resources.domains.create_subdomain_card_subtitle") }}</v-card-subtitle>
      <va-text-input
        class="subdomain-text-input"
        v-model.trim="form.name"
        :error-messages="errors.name"
        required
        :label="$t('resources.domains.subdomain_name')"
        :placeholder="$t('resources.domains.subdomain_name_placeholder')" />
      <div class="input-hint">{{ $t("resources.domains.subdomain_name_hint") }}</div>
      <va-text-input
        class="subdomain-text-input labeled"
        v-model.trim="url"
        :rules="[rules.url]"
        :error-messages="errors.url"
        required
        :label="$t('resources.domains.subdomain_url')"
        :placeholder="$t('resources.domains.subdomain_url_placeholder')"
        @change="$emit('isDirtyForm', true)">
        <template #prepend-inner>
          <div class="prepend-wrapper">https://</div>
        </template>
        <template #append>
          <div class="append-wrapper">
            {{ MAIN_DOMAIN_URL }}
          </div>
        </template>
      </va-text-input>
      <div class="input-hint">{{ $t("resources.domains.subdomain_url_hint") }}</div>
    </v-card>
  </va-form>
</template>

<script>
  import crudFormMixin from "@/mixins/crudFormMixin";
  import { DOMAIN_TYPE, MAIN_DOMAIN_URL } from "@/constant";
  import { urlValidation } from "@/utility/urlValidation";

  export default {
    name: "NewDomainForm",
    mixins: [crudFormMixin],
    props: {
      domain: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        url: "",
        requiredFormFields: ["name", "url"],
        form: {
          homepageTemplate: "blogs_primary",
        },
        rules: {
          url: value => urlValidation(`${value}${MAIN_DOMAIN_URL}`) || this.$t("generic.validation.url"),
        },
        errors: {},
        savedDomain: {},
        MAIN_DOMAIN_URL: MAIN_DOMAIN_URL,
      };
    },
    methods: {
      async submit() {
        if (!this.$refs.form.$refs.form.validate()) {
          return;
        }

        this.form.url = `${this.url}${MAIN_DOMAIN_URL}`;

        this.$emit("loading", true);
        try {
          const { data } = await this.$admin.dataProvider.create("domains", {
            data: {
              name: this.form.name,
              url: this.form.url,
              type: DOMAIN_TYPE.PROVIDED,
            },
          });
          this.savedDomain = data;
          this.$router.replace({
            name: "domains_show",
            params: { id: this.savedDomain.id },
            query: { tab: "domain_settings" },
          });
          this.$admin.toast.success(this.$t("resources.domains.connect_subdomain_success"));
        } catch (e) {
          this.errors = e.errors;
          this.$admin.toast.error(e.message || this.$t("generic.error"));
        } finally {
          this.$emit("loading", false);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";
  .input-hint {
    @include text-caption();
    color: get-color("subtitle");

    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  .subdomain-text-input {
    margin-bottom: 8px;

    &::v-deep {
      .v-input__slot {
        align-items: stretch;
      }

      .v-input__append-inner {
        padding: 0 !important;
      }

      .v-input__prepend-inner {
        align-self: stretch !important;
        padding: 0;
      }
    }

    &.labeled {
      &::v-deep {
        .v-text-field__slot {
          input {
            margin-left: 64px;
          }
        }

        .v-input__prepend-inner {
          width: 0;
        }
      }
    }
  }

  .append-wrapper {
    background: get-color("element-bg-200");
    display: flex;
    align-items: center;
    padding: 8px 16px;
    border-radius: 0 3px 3px 0;
    color: get-color("body");
  }

  .prepend-wrapper {
    background: get-color("element-bg-200");
    display: flex;
    align-items: center;
    padding: 8px;
    border-radius: 3px 0 0 3px;
    color: get-color("body");
  }
</style>
